import "./JobListPage.scss";
import FilterRow from "../../../component/filter-row/FilterRow";
import {
  CustomerDataEntry,
  JobStatusDataEntry,
  SiteDataEntry,
  WasteTypeDataEntry,
} from "../../../service/utils/interfaces";
import { jobStatusSelectorList } from "../../../service/utils/constants";
import Button from "../../../component/button/Button";
import TabsContainer from "../../../component/tabs-container/TabsContainer";
import TabContent from "./tab-content/TabContent";
import { SortSettings } from "../../../component/sortable-table/SortableTable";

interface JobListUIProps {
  isTippingUser: boolean;
  customerList: CustomerDataEntry[];
  sitesPerCustomer: SiteDataEntry[];
  wasteTypesPerCustomer: WasteTypeDataEntry[];
  startDate: Date | null;
  endDate: Date | null;
  currentTab: number;
  loadingData: boolean;
  headerJobsLine: string[];
  filteredJobsContent: (string | number)[][];
  sortSettings?: SortSettings;
  searchParam: string;
  headerIssuesLine: string[];
  filteredIssuesContent: (string | number)[][];

  resetTable: () => void;
  setSelectedCustomer: (customer: CustomerDataEntry) => void;
  setSelectedSites: (sites: SiteDataEntry[]) => void;
  setSelectedWasteTypes: (wasteTypes: WasteTypeDataEntry[]) => void;
  setSelectedStatus: (status: JobStatusDataEntry[]) => void;
  setDateRange: (update: [Date | null, Date | null]) => void;
  setCurrentTab: (tabIdx: number) => void;
  downloadExcelTable: () => void;
  changeSortAction: (col: number) => void;
  changeSearchParam: (search: string) => void;

  darkMode: boolean;
  width: number;
}

const JobListUI = (props: JobListUIProps) => {
  return (
    <div className={"job-wrapper" + (props.darkMode ? " dark" : "")}>
      <div className="filter-row row">
        <FilterRow
          width={props.width}
          isTippingUser={props.isTippingUser}
          customerData={props.customerList}
          onChangeCustomerData={(val) => {
            props.resetTable();
            props.setSelectedCustomer(val);
          }}
          siteData={props.sitesPerCustomer}
          onChangeSiteData={(val) => {
            props.resetTable();
            props.setSelectedSites([...val]);
          }}
          wasteTypeData={props.wasteTypesPerCustomer}
          onChangeWasteTypeData={(val) => {
            props.resetTable();
            props.setSelectedWasteTypes([...val]);
          }}
          statusData={jobStatusSelectorList}
          onChangeStatusData={(val) => {
            props.resetTable();
            props.setSelectedStatus([...val]);
          }}
          displayDateRange
          startDate={props.startDate}
          endDate={props.endDate}
          onChangeTimeRange={(update) => {
            props.resetTable();
            props.setDateRange(update);
          }}
          darkMode={props.darkMode}
        />
        <Button
          title="Export"
          className="export-button"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontSize: "var(--medium-font)",
          }}
          onClick={props.downloadExcelTable}
        />
      </div>
      <TabsContainer
        darkTheme={props.darkMode}
        tabList={["Job List", props.isTippingUser ? "Cardboard" : "Issues"]}
        contentList={TabContent({
          loadingData: props.loadingData,
          headerJobsLine: props.headerJobsLine,
          filteredJobsContent: props.filteredJobsContent,
          sortSettings: props.sortSettings,
          searchParam: props.searchParam,
          headerIssueLine: props.headerIssuesLine,
          filteredIssuesContent: props.filteredIssuesContent,
          isTippingUser: props.isTippingUser,
          changeSortAction: props.changeSortAction,
          changeSearchParam: props.changeSearchParam,
          width: props.width,
          darkMode: props.darkMode,
        })}
        currentTab={props.currentTab}
        onSwitchTab={(tabIdx) => {
          props.resetTable();
          props.setCurrentTab(tabIdx);
        }}
      />
    </div>
  );
};

export default JobListUI;
